import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { RouteReuseStrategy, RouterModule } from '@angular/router';
import { AuthModule, LogLevel } from 'angular-auth-oidc-client';
import {MatMenuModule} from '@angular/material/menu'; 
import {MatTabsModule} from '@angular/material/tabs'; 
import {MatDialogModule} from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';

import { AppComponent } from './app.component';
import { NavbarComponent } from './navbar/navbar.component';
import { ExplorerComponent } from './explorer/explorer.component';
import { FilesComponent } from './files/files.component';

import { MapComponent } from './map/map.component';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { ExplorersidebarComponent } from './explorer/explorersidebar/explorersidebar.component';
import { ExplorerbottombarComponent } from './explorer/explorerbottombar/explorerbottombar.component';

import { environment } from './../environments/environment';
import { CacheRouteReuseStrategy } from './cache-route-reuse.strategy';
import { SldeditorComponent } from './explorer/sldeditor/sldeditor.component';
import { FeatureinfoviewComponent } from './featureinfoview/featureinfoview.component';
import { FeatureinfochartComponent } from "./featureinfochart/featureinfochart.component";
import { SplitterComponent } from './splitter/splitter.component';
import {CdkDrag} from '@angular/cdk/drag-drop';

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    ExplorerComponent,
    FilesComponent,
    MapComponent,
    ExplorersidebarComponent,
    ExplorerbottombarComponent,
    SldeditorComponent,
    FeatureinfoviewComponent,
    SplitterComponent
  ],
  imports: [
    // ...
    MatMenuModule,
    MatTabsModule,
    MatDialogModule,
    AuthModule.forRoot({
        config: {
            authority: 'https://' + environment.authPrefix + '.' + environment.domain + '/realms/master',
            redirectUrl: environment.redirectUrl,
            postLogoutRedirectUri: environment.postLogoutRedirectUri,
            clientId: environment.clientId,
            scope: 'openid profile email description offline_access groups',
            responseType: 'code',
            silentRenew: true,
            useRefreshToken: true,
            logLevel: LogLevel.Warn,
        },
    }),
    BrowserModule,
    HttpClientModule,
    RouterModule.forRoot([
        { path: '', component: ExplorerComponent },
        { path: 'files', component: FilesComponent },
        { path: '**', component: ExplorerComponent },
    ], { useHash: true }),
    NoopAnimationsModule,
    FeatureinfochartComponent,
    CdkDrag,
    FormsModule
],
  providers: [{
    provide: RouteReuseStrategy,
    useClass: CacheRouteReuseStrategy
  }],
  bootstrap: [AppComponent]
})
export class AppModule { }
